var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFallbackAccountAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F0F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 23.5C26.1828 23.5 28.3571 21.3736 28.3571 18.75C28.3571 16.1264 26.1828 14 23.5 14C20.8172 14 18.6429 16.1264 18.6429 18.75C18.6429 21.3736 20.8172 23.5 23.5 23.5ZM26.9 24.6875H26.2663C25.4239 25.066 24.4866 25.2812 23.5 25.2812C22.5134 25.2812 21.5799 25.066 20.7337 24.6875H20.1C17.2844 24.6875 15 26.9215 15 29.675V31.2188C15 32.2021 15.8158 33 16.8214 33H30.1786C31.1842 33 32 32.2021 32 31.2188V29.675C32 26.9215 29.7156 24.6875 26.9 24.6875Z",
    fill: "#6B6F7C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallbackAccountAvatar);
export default __webpack_public_path__ + "static/media/fallback-account-avatar.566381be07d5044bd13722e8d54562bb.svg";
export { ForwardRef as ReactComponent };